import { render, staticRenderFns } from "./TextblockHome.vue?vue&type=template&id=422fff54&"
import script from "./TextblockHome.vue?vue&type=script&lang=js&"
export * from "./TextblockHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports